$(document).ready(function() {
  function initializeFlickity() {
    if (window.innerWidth <= 768) {
      $('.home-featured-col .featured-collection').flickity({
        contain: true, 
        cellAlign: 'center',
        pageDots: false,
        wrapAround: true,
        prevNextButtons: false,
      });
    }
  }

  // Initialize Flickity on page load
  initializeFlickity();

  // Reinitialize Flickity on window resize
  $(window).resize(function() {
    // Destroy Flickity instance if it exists
    var $gallery = $('.home-featured-col .featured-collection').data('flickity');
    if ($gallery) {
      $gallery.destroy();
    }
    // Reinitialize Flickity
    initializeFlickity();
  });
});
 

$(document).on("click",".filter-btn",function() {
  $('.c2-slider-faceted-filter-form').addClass("c2-slider-filter-form-active");
  $('body').addClass("c2-slider-filter-opened");
  $('.fillter-overlay').addClass("fillter-overlay-active");
});

$(document).on("click",".faceted_filtering_heading .icon",function() {
  $('.c2-slider-faceted-filter-form').removeClass("c2-slider-filter-form-active");
  $('body').addClass("c2-slider-filter-opened");
  $('.fillter-overlay').removeClass("fillter-overlay-active"); 
});

$(document).on("click",".fillter-overlay-active",function() {
  $('.c2-slider-faceted-filter-form').removeClass("c2-slider-filter-form-active");
  $('body').addClass("c2-slider-filter-opened");
  $('.fillter-overlay').removeClass("fillter-overlay-active");
});


// $(document).ready(function() {
//     const $dateInput = $('#proof-date');
//     let flatpickrInstance = null;

//     // Initialize Flatpickr if not already initialized
//     function initializeFlatpickr() {
//         if (flatpickrInstance === null) {
//             flatpickrInstance = $dateInput.flatpickr({
//                 inline: true,
//                 onChange: function(selectedDates, dateStr) {
//                     $dateInput.val(dateStr); // Set the selected date
//                 }
//             });
//         }
//     }

//     $('#date-picker-button').on('click', function() {
//         initializeFlatpickr();

//         // Toggle visibility of the Flatpickr calendar
//         const $calendar = $('.flatpickr-calendar');

//         if ($calendar.is(':visible')) {
//             // Hide the calendar
//             $calendar.hide();
//         } else {
//             // Show the calendar
//             $calendar.show();
//         }
//     });

//     // Hide the date input initially
//     $dateInput.hide(); 
// });

 


// Footer Menu Heading Click Event
$(document).on("click", ".footer__menu .footer__heading", function() { 
  var $parent = $(this).parent();
  var $content = $parent.find('ul'); // Assuming the content to slide is a <ul> inside the parent

  if ($parent.hasClass("menu-open")) {
    // Close the menu
    $content.stop(true, true).slideUp(300, function() {
      $parent.removeClass("menu-open");
    });
  } else {
    // Close any other open menus (optional)
    $(".footer__menu.menu-open").each(function() {
      var $otherParent = $(this);
      $otherParent.removeClass("menu-open");
      $otherParent.find('ul').stop(true, true).slideUp(300);
    }); 

    // Ensure the content is fully hidden before starting slideDown
    $content.css('display', 'none'); // Ensure initial state is hidden
    $parent.addClass("menu-open");
    $content.stop(true, true).slideDown(500);
  }
}); 


// Newsletter Title Click Event
$(document).on("click", ".newsletter_title", function() {
  $(this).toggleClass("menu-open");
  $('.newsletter_form_mobile').slideToggle(300); 
});

// Mobile Menu Heading Back Click Event
$(document).on("click", ".c2-mobile-menu-heading-back", function() {
  $('.mobile-menu__list-item input[type=checkbox]:checked').click();
  $('.mobile-menu__toggle-button').removeClass("hide_mobile-menu__toggle-button");
});




 
document.addEventListener('DOMContentLoaded', function() { 
  const quantityOptions = document.querySelectorAll('.quantity-option');
  const quantityInput = document.querySelector('.quantity-input');
  const selectedQuantityInput = document.getElementById('selected-quantity');

  quantityOptions.forEach(option => {
    option.addEventListener('click', function() { 
      const selectedQuantity = this.getAttribute('data-quantity');
      // quantityInput.value = selectedQuantity;
      selectedQuantityInput.value = selectedQuantity;
      updateQuantity(selectedQuantity);
    });
  }); 

  function updateQuantity(quantity) {
    quantityOptions.forEach(option => option.classList.remove('selected'));
    const selectedOption = [...quantityOptions].find(option => option.getAttribute('data-quantity') === quantity);
    if (selectedOption) {
      selectedOption.classList.add('selected'); 
    }
  }
});


    $(document).ready(function() {
      let quantitySelected = false; 

      // Click event for quantity options
      $('.quantity-option').on('click', function() {
        // Remove the 'selected' class from all options
        $('.quantity-option').removeClass('selected');
        
        // Mark the clicked option as selected
        $(this).addClass('selected');
        
        // Update the hidden input with the selected quantity
        const selectedQuantity = $(this).data('quantity');
        $('#selected-quantity').val(selectedQuantity); 
        
        // Enable the Next button
        quantitySelected = true;
        $('.product-button-next').prop('disabled', !quantitySelected);
      });

      // Initially disable the Next button
      $('.product-button-next').prop('disabled', true);
    });
 

$(document).ready(function() {
    let currentStep = 0; 

    // Check if the Flavors section is present 
    let flavors = $('[data-option-index="0"]');
    let hasFlavors = flavors.length > 0;

    // Check if the Quantity section is present  
    let quantity = $('[data-option-index="1"]');
    let hasQuantity = quantity.length > 0;

    $('[data-option-index="0"]').css('display', 'block'); 
    $('[data-option-index="1"]').css('display', 'block');  
    $('.product-quantities').css('display', 'block'); 
    $('.product-button-back').css('display', 'none'); 
    $('.product-button-next').css('display', 'none');
    $('.purchase-details .purchase-details__spb--false .button--add-to-cart').css('display', 'none');  
    $('.product-button-cart').css('display', 'block'); 
    // $('.custom-image').css('display', 'none'); 
 
    // Function to hide all sections
    function hideAllSections() {
        $('[data-option-index="0"]').css('display', 'block');
        $('[data-option-index="1"]').css('display', 'block');
        $('.product-quantities').css('display', 'block');
        $('.product-button-next').css('display', 'none');
        $('.product-button-cart').css('display', 'none');
        // $('.custom-image').css('display', 'none');
    }

    // Function to show the Add to Cart button
    function showAddToCartButton() {
        $('.purchase-details .purchase-details__spb--false .button--add-to-cart').css('display', 'none');  
        $('.product-button-next').css('display', 'none'); 
        $('.product-button-cart').css('display', 'none'); 
        $('.product-button-back').css('display', 'none'); 
    }

  
    // Function to show the Next button
    function showNextButton() {
        $('.purchase-details .purchase-details__spb--false .button--add-to-cart').css('display', 'none'); 
        $('.product-button-next').css('display', 'none'); 
        $('.product-button-cart').css('display', 'block'); 
        $('.product-button-back').css('display', 'none');  
    } 
 

  
    $('.product-button-cart').on('click', function() { 
        $('.purchase-details .purchase-details__spb--false .button--add-to-cart').trigger('click'); 
    });

    // Observe changes to the show-custom-image class
    const customImageElement = document.querySelector('.custom-image');

    if (customImageElement) { 
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if ($(mutation.target).hasClass('show-custom-image')) {
                    // hideAllSections();
 
                    // Show the appropriate button based on the selected option
                    if ($('[data-option-index="1"] input:checked').length === 0) {
                        $('.custom-image').css('display', 'block'); 
                        $('.product-button-next').css('display', 'none');
                        $('.product-button-cart').css('display', 'flex');
                    } else {
                        $('.custom-image').css('display', 'block'); 
                        $('.product-button-cart').css('display', 'flex');
                        $('.product-button-next').css('display', 'none');
                    }

                    $('.product-button-back').css('display', 'none');
                    currentStep = 4; // Move to custom step
                } 
            });
        });

        // Start observing the custom image section for class changes
        observer.observe(customImageElement, {
            attributes: true,
            attributeFilter: ['class']
        });
    } else {
        console.warn("Custom image element not found.");
    }
});

$(document).ready(function() { 
    let flavorSelected = false;
    let LabelSelected = false;
    let quantitySelected = false;

  $('.product-button-cart')
        .prop('disabled', true)
        .addClass('disabled')
        .attr('title', 'Please select all options before adding to cart');

    if(document.querySelector('.label_type input:checked') || document.querySelectorAll('.label_type input').length > 0){
      LabelSelected = true;
      checkSelections();
    }

    if(document.querySelector('.quantity-option.selected') || !document.querySelector('.product-quantities')){
      quantitySelected = true;
      checkSelections();
    }

    if(document.querySelector('.flavour-selector input:checked')){
      flavorSelected = true; 
      checkSelections();
    }

    // Disable cart button initially and add tooltip
    

    // Click event for Flavors
    $('.product_form options-selection .flavour-selector input').on('click', function() {
      
        var current_flavour_selected = document.querySelectorAll('.swatch-checkbox:checked').length;
        var max_flavour_selection = parseInt(document.querySelector('.new-swatch.flavour-selector').getAttribute('data-max-selection'), 10); 
        $('[data-option-index="0"] .flavor-option').removeClass('selected');
        $(this).addClass('selected');
        if(current_flavour_selected >= max_flavour_selection){
         flavorSelected = true; 
         checkSelections();  
        }else{
         flavorSelected = false; 
         checkSelections(); 
        }
    });

     if($('.label_type .swatch__option input')){
      $('.label_type .swatch__option input').on('click', function() {
          LabelSelected = true;
          checkSelections();
      }); 
     } 

    // Click event for Quantity options
    $('.quantity-option').on('click', function() {
        $('.quantity-option').removeClass('selected');
        $(this).addClass('selected');
        $('#selected-quantity').val($(this).data('quantity'));
        quantitySelected = true;
        checkSelections();
    });

    function checkSelections() {
        if($('.label_type .swatch__option input')){
          
          if (flavorSelected && quantitySelected && LabelSelected) {
            $('.product-button-cart')
                .prop('disabled', false)
                .removeClass('disabled') 
                .removeAttr('title'); // Remove tooltip when enabled
          } else {
              $('.product-button-cart') 
                  .prop('disabled', true)
                  .addClass('disabled')
                  .attr('title', 'Please select all options before adding to cart'); // Add tooltip
          }  
        }else{
          if (flavorSelected && quantitySelected) {
            $('.product-button-cart')
                .prop('disabled', false) 
                .removeClass('disabled')
                .removeAttr('title'); // Remove tooltip when enabled
          } else { 
              $('.product-button-cart')
                  .prop('disabled', true)
                  .addClass('disabled')
                  .attr('title', 'Please select all options before adding to cart'); // Add tooltip
          } 
        }
    }

    // Cart button trigger
    $('.product-button-cart').on('click', function() {
        if (flavorSelected && quantitySelected) {
            $('.purchase-details .purchase-details__spb--false .button--add-to-cart').trigger('click');
        }
    });
});






 

 

document.addEventListener("DOMContentLoaded", function () {
  var addOnCheckboxes = document.querySelectorAll(".addonProdInput");

  addOnCheckboxes.forEach(function (checkbox) { 
    checkbox.addEventListener("change", function () {
      if (checkbox.checked) {
        addAddOnProductToCart(checkbox.dataset.varId);
      } else {
        removeAddOnProductFromCart(checkbox.dataset.varId);  
      }
    });
  });

  function addAddOnProductToCart(variantId) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Product added to cart:", data);
        updateCartUI();
      }) 
      .catch((error) => {
        console.error("Error adding product to cart:", error);
      });
  }

  function removeAddOnProductFromCart(variantId) {
    // First fetch the cart to find the line number for the variantId 
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // Find the line item that matches the variantId
        const lineItem = cart.items.find((item) => item.variant_id == variantId);

        if (lineItem) { 
          fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            }, 
            body: JSON.stringify({
              line: lineItem.line, // Use the correct line number
              quantity: 0,         // Set quantity to 0 to remove the item
            }),
          }) 
            .then((response) => response.json())
            .then((data) => {
              console.log("Product removed from cart:", data);
              updateCartUI();
            })
            .catch((error) => {
              console.error("Error removing product from cart:", error);
            });
        } else {
          console.error("Product not found in cart.");
        }
      })  
      .catch((error) => {
        console.error("Error fetching cart data:", error);
      }); 
  }

  function updateCartUI() { 
    fetch("/cart.js") 
      .then((response) => response.json())
      .then((cart) => {
        console.log("Cart updated:", cart);
        // Update your cart UI here
        // For example, update the cart count, subtotal, etc.
      })
      .catch((error) => {
        console.error("Error fetching cart data:", error);
      });
  }
});

 

$(document).ready(function() {
    $('#custom_image_1').on('change', function() {
        var file = this.files[0];
        if (file) { 
            // Update the text and image icon
            $('#upload-text').text('Image Uploaded');
            $('#uploaded-image-logo').attr('src', '{{ "checkmark-icon.png" | asset_url }}'); // Update with your checkmark icon 

            // Show the image name
            $('#uploaded-image-info').text(`(${file.name})`).css('display', 'inline'); 
        } 
    });
}); 

 
document.addEventListener('DOMContentLoaded', function () {
  const checkboxes = document.querySelectorAll('.swatch-checkbox');
  const swatchContainer = document.querySelector('.new-swatch');  
  const maxSelection = parseInt(swatchContainer.getAttribute('data-max-selection'), 10); 

  function updateCheckboxSelection() {
    const selectedFlavors = [];

    checkboxes.forEach(box => {
      if (box.checked) {
        selectedFlavors.push(box.value); 
      }
    });

    if (maxSelection > 1) {
      if (selectedFlavors.length >= maxSelection) {
        checkboxes.forEach(box => {
          if (!box.checked) {
            box.disabled = true; // Disable unchecked boxes 
          }
        });
      } else {
        checkboxes.forEach(box => {
          box.disabled = false; // Enable all boxes
        }); 
      }
    }

    // Update selected class for all
    checkboxes.forEach(box => {
      const swatchOption = box.closest('.swatch__option');
      if (box.checked) {
        swatchOption.classList.add('selected');
      } else {
        swatchOption.classList.remove('selected');
      }
    });

    console.log("Selected Flavors:", selectedFlavors);
  }

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function () {
      if (maxSelection === 1) {
        if (this.checked) {
          // Uncheck all others
          checkboxes.forEach(cb => {
            if (cb !== this) {
              cb.checked = false; 
              cb.closest('.swatch__option').classList.remove('selected');
            }
          });
        }
        // Toggle selected class for current checkbox
        const swatchOption = this.closest('.swatch__option');
        if (this.checked) {
          swatchOption.classList.add('selected');
        } else {
          swatchOption.classList.remove('selected');
        }
        console.log("Selected Flavor:", this.checked ? this.value : 'None');
      } else {
        updateCheckboxSelection();
      }
    });
  });

  updateCheckboxSelection();
});



 

  
let selectedFlavors = [];   

document.querySelectorAll('.swatch-checkbox').forEach(function(checkbox, index) { 
  checkbox.addEventListener('change', function() {
    let flavorName = this.value; 

    if (this.checked) {
      selectedFlavors.push({ 
        index: index, 
        flavorName: flavorName,
        inputElement: this
      });
    } else {
      selectedFlavors = selectedFlavors.filter(function(item) {
        return item.flavorName !== flavorName;
      });
    }
 
    selectedFlavors.sort(function(a, b) {
      return a.index - b.index;
    });

    selectedFlavors.forEach(function(item, i) {
      let sequenceNumber = i + 1;
      item.inputElement.setAttribute('name', 'properties[flavor-' + sequenceNumber + ']');
    }); 

    console.log(selectedFlavors); 
  });
}); 

 

$(document).ready(function() { 
    const $dateInput = $('#proof-date');
    const $selectedDate = $('#selected-date');
    // const $cartNotes = $('.cart__notes #note'); 
    const $dateWarning = $('#date-warning');

    // Initialize Flatpickr
    const flatpickrInstance = $dateInput.flatpickr({ 
        inline: true, 
        appendTo: document.getElementById('date-picker-container'), 
        onChange: function(selectedDates, dateStr) {
            if (dateStr) {
                const formattedDate = `Selected Date: ${dateStr}`;
              let cartAttributes={};  
              cartAttributes["Selected Date"] = dateStr;
                $dateInput.val(dateStr);
                $selectedDate.text(formattedDate).show();
                // Send update request to Shopify
                $.ajax({
                    type: 'POST', 
                    url: '/cart/update.js',
                    data: {
                        attributes: cartAttributes,
                    },
                    dataType: 'json',
                    success: function() {
                        console.log('Cart note and attributes updated successfully');
                    },
                    error: function() {
                        console.error('Failed to update cart note and attributes'); 
                    }
                });

                $('.flatpickr-calendar.inline').hide(); 
            }
        },
        onReady: function() {
            $('.flatpickr-calendar.inline').hide();
        }
    });

    // Button to toggle calendar visibility
    $('#date-picker-button').on('click', function() {
        $('.flatpickr-calendar.inline').toggle();
    });

    // Checkout button logic
    $('.checkout').on('click', function(e) {
        if (!$dateInput.val()) {
            e.preventDefault(); // Prevent checkout if no date is selected
            $dateWarning.show(); // Show warning only when checkout is clicked without a date
        } else {
            $dateWarning.hide(); // Hide warning if date is already selected
        }
    });

    $dateInput.hide();
});







